import { apiSlice } from "../api/apiSlice";
import { projectIdToggled } from "../tasks/tasksSlice";

export const projectsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjects: builder.query({
      query: () => `/projects`,
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
            const projects = await queryFulfilled;
            if (projects?.data?.length > 0) {
                projects.data.map(project=>{
                  dispatch(projectIdToggled(project.id));
                })
            }
        } catch (err) {}
    },
    }),
  })
})

export const {useGetProjectsQuery} = projectsApi;